import store from '@/store/store'
import { RawLocation, Route } from 'vue-router'
import Vue from 'vue'
import crisp from '@/utils/middleware/crisp'
import auth from '@/middleware/auth'
import locale from '@/middleware/locale'

export default async function(
    to: Route,
    from: Route,
    next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void
) {
    await auth(to, from, next)
    await locale(to, from, next)
    crisp(to)

    store.commit('app/UPDATE_PATH', { path: to.path })

    next()
}
